export default __webpack_public_path__ + "static/media/16.0487bd16.jpg";